import axios from 'axios';

import { type Common } from '../common.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async uploadCareGapFindings(formData: FormData) {
    const url = this.common.constructPath(`/patient-findings/upload/care-gap`);
    return await axios.put(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    });
  }

  async uploadHccFindings(formData: FormData) {
    const url = this.common.constructPath(`/patient-findings/upload/hcc`);
    return await axios.put(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  }
}
